import {AlertEnum} from '../changeDataAlertStore/types';

const DEFAULT_OTP_MODAL_STATE_STORE = {
	open: false,
	type: AlertEnum.NONE,
	data: undefined,
	isAbandoned: false,
};

export {DEFAULT_OTP_MODAL_STATE_STORE};
